import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Input, OnChanges } from '@angular/core';
import { FunnelTemplateStage } from '@app/models/recruiting/funnel-template-stages.model';
import { FunnelTemplate } from '@app/models/recruiting/funnel-template.model';
import { FunnelStageAndMessageTemplate } from '@applicant-tracker/interfaces/funnel-stage-and-message-template.interface';

@Component({
    selector: 'app-funnel-template-form',
    templateUrl: './funnel-template-form.component.html',
    styleUrls: ['./funnel-template-form.component.scss'],
})
export class FunnelTemplateForm implements OnChanges {
    @Input() funnelTemplate: FunnelTemplate = new FunnelTemplate();
    @Input() funnelStageAndMessageTemplates: FunnelStageAndMessageTemplate[] = [];
    @Input() temporaryDelete = false;

    ngOnChanges(): void {
        // Want to sort every time a binding is updated
        this.sortByStageIndex();
    }

    drop(event: CdkDragDrop<string[]>): void {
        moveItemInArray(this.funnelStageAndMessageTemplates, event.previousIndex, event.currentIndex);
        this.funnelStageAndMessageTemplates.forEach(
            (funnelStageAndMessageTemplate: FunnelStageAndMessageTemplate, index: number) => {
                funnelStageAndMessageTemplate.funnelTemplateStage.stageIndex = index;
            }
        );
    }

    async onDeleteFunnelStage(stage: FunnelTemplateStage, index: number): Promise<void> {
        await stage.delete();
        this.funnelStageAndMessageTemplates.splice(index, 1);
    }

    onDelete(index: number): void {
        this.funnelStageAndMessageTemplates.splice(index, 1);
    }

    sortByStageIndex(): void {
        if (!this.funnelStageAndMessageTemplates?.length) {
            return;
        }

        this.funnelStageAndMessageTemplates.sort(
            (a: FunnelStageAndMessageTemplate, b: FunnelStageAndMessageTemplate) =>
                a.funnelTemplateStage.stageIndex - b.funnelTemplateStage.stageIndex
        );
    }
}
